// src/components/Video.jsx
import React, { useRef, useState, useEffect } from "react";
import "./Video.css";

const VideoSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showInitialPlay, setShowInitialPlay] = useState(true);

  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const handleProgressChange = (e) => {
    const video = videoRef.current;
    const newTime = (e.target.value / 100) * video.duration;
    video.currentTime = newTime;
  };

  const updateProgress = () => {
    const video = videoRef.current;
    const percent = (video.currentTime / video.duration) * 100;
    setProgress(percent);
  };

  const handleVideoClick = () => {
    if (!showInitialPlay) {
      setShowControls((prev) => !prev);
    }
  };

  const handleInitialPlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
    setShowInitialPlay(false);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.addEventListener("timeupdate", updateProgress);
    return () => {
      video.removeEventListener("timeupdate", updateProgress);
    };
  }, []);

  return (
    <section id="video">
    <div className="video-container">
      <h2 className="section-heading">Our Video</h2>

      <div className="video-wrapper" onClick={handleVideoClick}>
        <video
          ref={videoRef}
          src="/video.mp4"
          loop
          playsInline
          className="responsive-video"
        />

        {showInitialPlay && (
          <button className="initial-play-button" onClick={handleInitialPlay}>
            ▶
          </button>
        )}

        {!showInitialPlay && showControls && (
          <div className="custom-controls">
            <button className="custom-play-button" onClick={togglePlayback}>
              {isPlaying ? "⏸" : "▶"}
            </button>

            <input
              type="range"
              className="video-progress"
              value={progress}
              onChange={handleProgressChange}
            />
          </div>
        )}
      </div>
    </div>
    </section>
  );
};

export default VideoSection;
